Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Dropdown2515301461",
  {"showPointer":"Dropdown2515301461--showPointer","root":"Dropdown2515301461--root"},
  ".Dropdown2515301461--showPointer{cursor:pointer}.Dropdown2515301461--showPointer[data-dropdown2515301461-noborder]{border:none}",
  1,
  "Dropdown2515301461"
);
__webpack_require__.stylable.$.register(exports.default)
